module.exports = __webpack_public_path__ + "static/img/ytcx.08905a3b.png";